import React from 'react'
import './BusinessAdvantages.scss'
import BusinessAdvantagesCard from './BusinessAdvantagesCard/BusinessAdvantagesCard'

const BusinessAdvantages = ({data}) => {
  return (
    <div className='businessAdvantages_container' id='advantages'>
      <div className="businessAdvantages_block">
        <h2>Преимущества</h2>
        <div className="businessAdvantages_item">
          {
            data?.map((i)=>
            <BusinessAdvantagesCard key={i.id} img={i.img} text={i.text}/>
            )
          }
        </div>
      </div>
    </div>
  )
}

export default BusinessAdvantages
